import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from '../actions/MenuAction';

class FavItemMainStore extends EventEmitter {
    PageLoadData = "";
    deleteresponse = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleFavItemMainStore = (action) => {
        switch (action.action.type) {
            case SDIConstants.methodNames.FavItemMaintenance_PageLoad: {
                this.PageLoadData = action.action.response;
                this.emit('favItemload');
                break;
            }

            case SDIConstants.methodNames.FavItemMaintenance_txtid_TextChanged: {
                this.PageLoadData = action.action.response;
                this.emit('NewfavItem');
                break;
            }

            case SDIConstants.methodNames.FavItemMaintenance_InsertFavItem: {
                this.PageLoadData = action.action.response;
                this.emit('InsertfavItem');
                break;
            }

            case SDIConstants.methodNames.FavItemMaintenance_DeleteFavItem: {
                this.PageLoadData = action.action.response;
                this.emit('DeleteItem');
                break;
            }


            case SDIConstants.methodNames.FavItemMaintenance_UpdateFavItem: {
                this.PageLoadData = action.action.response;
                this.emit('UpdateFavItem');
                break;
            }


            case SDIConstants.methodNames.Menu_AddFavItemtoCart: {
                MenuAction.refreshCartCount();
                this.PageLoadData = action.action.response;
                this.emit('addedtoCart');
                break;
            }
            case "FAVITEM_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "FAVITEM_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "FAVITEM_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
            //WAL-714_PC_11
            case SDIConstants.methodNames.ShareFavItem: {
                this.pageLoadData = action.action.response;
                this.emit('ShareItem');
                break;
            }
            //WW-419_PC_06 (5/25/2022) -Aparna
            case SDIConstants.methodNames.DeleteMultipleFavItem: {
                this.deleteresponse = action.action.response;
                this.emit('MultiDelete');
                break;
            }

        }
    }
}
const objFavItemStore = new FavItemMainStore;
// Dispatcher code
Dispatcher.register(objFavItemStore.handleFavItemMainStore.bind(objFavItemStore));
export default objFavItemStore;